"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractFeatures = void 0;
var ContractFeatures;
(function (ContractFeatures) {
    ContractFeatures["STABLE_COIN"] = "STABLE_COIN";
})(ContractFeatures || (exports.ContractFeatures = ContractFeatures = {}));
//# sourceMappingURL=contact.js.map